<div class="thinking-dialog">
  <mat-spinner diameter="60"></mat-spinner>
  <h2 class="thinking-word">{{ currentWord }}...</h2>
  <p>Please wait while we process your request</p>
</div>
